'use client';

import { ReactNode, useEffect } from 'react';

// Types
import { ProductBackgroundColour } from '@/types/styling/product';

// Contexts
import { useProductDetailsContext } from '@/context/ProductDetailsProvider';

type SliceWrapperProps = {
  children: ReactNode;
  colourScheme: ProductBackgroundColour | undefined;
};

export const SliceWrapper = ({ children, colourScheme }: SliceWrapperProps) => {
  const { setColourScheme } = useProductDetailsContext();

  useEffect(() => {
    setColourScheme(colourScheme);
  }, [colourScheme]);

  return <>{children}</>;
};
